export default "__VITE_ASSET__BOPPVegP__"